import { render, staticRenderFns } from "./SearchModule.vue?vue&type=template&id=0ae4a53f&scoped=true&"
import script from "./SearchModule.vue?vue&type=script&lang=js&"
export * from "./SearchModule.vue?vue&type=script&lang=js&"
import style0 from "./SearchModule.vue?vue&type=style&index=0&id=0ae4a53f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae4a53f",
  null
  
)

export default component.exports